import { classNames } from '@utils/classNames';
import { BadgeListItem } from './BadgeListItem';

type BadgeListProps = {
  items: string[];
  activeIndex: number;
  className?: string;
};

export const BadgeList = ({
  items,
  activeIndex,
  className,
}: BadgeListProps) => {
  return (
    <div
      className={classNames('flex space-x-2 w-full', className)}
      data-testid="badge-list"
    >
      {items.map((item, index) => (
        <BadgeListItem
          key={index}
          item={item}
          isActive={index === activeIndex}
        />
      ))}
    </div>
  );
};
